(function () {
  'use strict';
  if (window.ecCalculadoraMesaInitialized) return;
  window.ecCalculadoraMesaInitialized = true;

  var pendingMesaSubmit = null;
  var _origFetch = window.fetch;

  window.fetch = function (resource, init) {
    if (pendingMesaSubmit && init && init.body instanceof FormData) {
      var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      if (url.indexOf('/cart/add') !== -1) {
        var data = pendingMesaSubmit;
        pendingMesaSubmit = null;
        init.body.set('quantity', String(data.qty));
        init.body.set('properties[Width]', data.width);
        init.body.set('properties[Length]', data.length);
        init.body.set('properties[_Square meters]', String(data.qty));
        init.body.set('properties[_Square feets]', '');
        init.body.set('properties[_is_calculadora_mesa]', 'Sim');
      }
    }
    return _origFetch.apply(this, arguments);
  };

  var STEP_M = 0.2;
  var MESA_COMP_LEN_THRESHOLD_M = 3.6;
  var MESA_COMP_LEN_DIVISOR_M = 1.75;

  function ecMesaFormatMoney(cents) {
    var c = parseInt(cents, 10) || 0;
    if (window.Shopify && window.Shopify.formatMoney) {
      var fmt = (window.Shopify.money_format || '').trim();
      if (fmt) return window.Shopify.formatMoney(c, fmt);
    }
    return '$' + (c / 100).toFixed(2);
  }

  function ecMesaParseDimension(val) {
    if (val === '' || val === null) return NaN;
    return parseFloat(String(val).trim().replace(',', '.'));
  }

  function isMultipleOfStepM(val) {
    var n = Math.abs(val) / STEP_M;
    return Math.abs(n - Math.round(n)) < 1e-6;
  }

  function validateValue(val, min, max) {
    if (val === '' || val === null) return 'Required field';
    var num = ecMesaParseDimension(val);
    if (isNaN(num)) return 'Invalid value';
    if (num < min) return 'Min: ' + min + ' CM';
    if (max !== null && num > max) return 'Max: ' + max + ' CM';
    if (!isMultipleOfStepM(num / 100)) return 'Must be a multiple of ' + (STEP_M * 100) + ' CM';
    return '';
  }

  function ecMesaQtyM2FromMeters(larguraM, comprimentoM) {
    var areaM2 = larguraM * comprimentoM;
    return Math.ceil(areaM2);
  }

  function ecMesaComputeComposicaoFromLengthM(comprimentoM) {
    if (isNaN(comprimentoM) || comprimentoM <= 0) return null;
    var tampo =
      comprimentoM < MESA_COMP_LEN_THRESHOLD_M
        ? 2
        : Math.floor(comprimentoM / MESA_COMP_LEN_DIVISOR_M);
    var pares = ((tampo * 2) + 2) / 2;
    return { tampo: tampo, pares: pares };
  }

  function ecMesaAutoDescriptionEnglish(tops, pairs) {
    var t = String(tops);
    var p = String(pairs);
    return 'This table includes ' + t + ' tops and ' + p + ' pairs of legs.';
  }

  function ecMesaUpdateComposicaoUI(container) {
    var out = container.querySelector('[data-ec-mesa-calculator-desc]');
    if (!out) return;
    var inputC = container.querySelector('.ec-calculadora-mesa__comprimento');
    var comprimentoMin = parseFloat(container.getAttribute('data-comprimento-min')) || 0;
    if (!inputC) {
      out.textContent = '';
      return;
    }
    var eC = validateValue(inputC.value, comprimentoMin, null);
    if (eC || inputC.value === '') {
      out.textContent = ecMesaAutoDescriptionEnglish('\u2014', '\u2014');
      return;
    }
    var lenM = ecMesaParseDimension(inputC.value) / 100;
    var comp = ecMesaComputeComposicaoFromLengthM(lenM);
    if (!comp) {
      out.textContent = ecMesaAutoDescriptionEnglish('\u2014', '\u2014');
      return;
    }
    out.textContent = ecMesaAutoDescriptionEnglish(comp.tampo, comp.pares);
  }

  function ecMesaSetPdpPriceReplacement(productInfo, active) {
    if (!productInfo) return;
    productInfo.querySelectorAll('[data-ec-mesa-pdp-base-price]').forEach(function (base) {
      base.hidden = !!active;
    });
  }

  function ecMesaGetIsCustomDimensionForSection(sectionId) {
    var productInfo = document.getElementById('ProductInfo-' + sectionId);
    if (!productInfo) return false;
    var gate = document.querySelector('.ec-mesa-calculator-gate[data-section-id="' + sectionId + '"]');
    if (!gate) return true;
    var heightRoot = productInfo.querySelector('.ec-height-select[data-ec-mesa-gate="true"]');
    if (!heightRoot) return true;
    var customLabel =
      heightRoot.getAttribute('data-custom-height-value') ||
      gate.getAttribute('data-custom-dimension-label') ||
      '';
    var sel = heightRoot.querySelector('.ec-height-select__option--selected');
    var val = sel ? sel.getAttribute('data-value') : '';
    return (
      (val === customLabel && customLabel !== '') ||
      (sel && sel.getAttribute('data-ec-mesa-custom-dimension') === 'true')
    );
  }

  function ecMesaFindDefaultBuyBlockWrapper(productInfo) {
    var forms = productInfo.querySelectorAll('product-form.product-form');
    for (var i = 0; i < forms.length; i++) {
      var pf = forms[i];
      if (pf.closest('.ec-mesa-calculator-gate')) continue;
      if (pf.closest('.ec-calculadora:not(.ec-calculadora-mesa)')) continue;
      var wrap = pf.parentElement;
      if (wrap && wrap.tagName === 'DIV') return wrap;
    }
    return null;
  }

  function ecMesaSyncDefaultBuyVisibility(productInfo, sectionId) {
    if (!productInfo || !sectionId) return;
    var gate = document.querySelector('.ec-mesa-calculator-gate[data-section-id="' + sectionId + '"]');
    if (!gate) return;
    var wrap = ecMesaFindDefaultBuyBlockWrapper(productInfo);
    if (!wrap) return;
    if (ecMesaGetIsCustomDimensionForSection(sectionId)) {
      wrap.setAttribute('hidden', 'hidden');
    } else {
      wrap.removeAttribute('hidden');
    }
  }

  function ecMesaUpdateSimQtyForSection(sectionId) {
    var productInfo = document.getElementById('ProductInfo-' + sectionId);
    if (!productInfo) return;
    var wraps = productInfo.querySelectorAll('[data-ec-mesa-sim-qty-wrap]');
    if (!wraps.length) return;
    var isCustom = ecMesaGetIsCustomDimensionForSection(sectionId);

    function clearWraps() {
      ecMesaSetPdpPriceReplacement(productInfo, false);
      wraps.forEach(function (w) {
        w.hidden = true;
        var o = w.querySelector('[data-ec-mesa-sim-qty-output]');
        if (o) {
          o.textContent = '';
          o.hidden = true;
        }
      });
    }

    if (!isCustom) {
      clearWraps();
      return;
    }

    var container = productInfo.querySelector('.ec-calculadora-mesa[data-section-id="' + sectionId + '"]');
    if (!container) {
      clearWraps();
      return;
    }
    var inputLargura = container.querySelector('.ec-calculadora-mesa__largura');
    var inputComprimento = container.querySelector('.ec-calculadora-mesa__comprimento');
    if (!inputLargura || !inputComprimento) {
      clearWraps();
      return;
    }
    var larguraMin = parseFloat(container.getAttribute('data-largura-min')) || 0;
    var larguraMaxAttr = container.getAttribute('data-largura-max');
    var larguraMax = larguraMaxAttr !== null && larguraMaxAttr !== '' ? parseFloat(larguraMaxAttr) : null;
    var comprimentoMin = parseFloat(container.getAttribute('data-comprimento-min')) || 0;
    var eL = validateValue(inputLargura.value, larguraMin, larguraMax);
    var eC = validateValue(inputComprimento.value, comprimentoMin, null);
    if (eL || eC || inputLargura.value === '' || inputComprimento.value === '') {
      clearWraps();
      return;
    }
    var l = (ecMesaParseDimension(inputLargura.value) || 0) / 100;
    var c = (ecMesaParseDimension(inputComprimento.value) || 0) / 100;
    var qty = ecMesaQtyM2FromMeters(l, c);
    if (qty < 1) {
      clearWraps();
      return;
    }
    var unitCents = parseInt(container.getAttribute('data-unit-price') || '0', 10) || 0;
    var totalCents = qty * unitCents;
    var text = ecMesaFormatMoney(totalCents);
    wraps.forEach(function (w) {
      w.hidden = false;
      var o = w.querySelector('[data-ec-mesa-sim-qty-output]');
      if (o) {
        o.textContent = text;
        o.hidden = false;
      }
    });
    ecMesaSetPdpPriceReplacement(productInfo, true);
  }

  function initMesaCalculadora(blockId) {
    var container = document.querySelector('.ec-calculadora-mesa[data-block-id="' + blockId + '"]');
    if (!container) {
      setTimeout(function () { initMesaCalculadora(blockId); }, 100);
      return;
    }

    var productForm = container.querySelector('product-form');
    var inputLargura = container.querySelector('.ec-calculadora-mesa__largura');
    var inputComprimento = container.querySelector('.ec-calculadora-mesa__comprimento');

    if (!productForm || !inputLargura || !inputComprimento) {
      setTimeout(function () { initMesaCalculadora(blockId); }, 100);
      return;
    }

    var form = productForm.querySelector('form');
    if (!form) {
      setTimeout(function () { initMesaCalculadora(blockId); }, 100);
      return;
    }

    var larguraMin = parseFloat(container.getAttribute('data-largura-min')) || 0;
    var larguraMaxAttr = container.getAttribute('data-largura-max');
    var larguraMax = (larguraMaxAttr !== null && larguraMaxAttr !== '') ? parseFloat(larguraMaxAttr) : null;
    var comprimentoMin = parseFloat(container.getAttribute('data-comprimento-min')) || 0;

    var errorLargura = container.querySelector('.ec-calculadora-mesa__error--largura');
    var errorComprimento = container.querySelector('.ec-calculadora-mesa__error--comprimento');
    var sectionId = container.getAttribute('data-section-id');

    function setError(el, msg) {
      if (el) el.textContent = msg || '';
    }

    function calculateQty() {
      var l = (ecMesaParseDimension(inputLargura.value) || 0) / 100;
      var c = (ecMesaParseDimension(inputComprimento.value) || 0) / 100;
      return ecMesaQtyM2FromMeters(l, c);
    }

    function syncSubmitWithProductForm() {
      document.dispatchEvent(new CustomEvent('product-form:validate'));
      ecMesaUpdateComposicaoUI(container);
      if (sectionId) ecMesaUpdateSimQtyForSection(sectionId);
    }

    function buildPendingData() {
      var qty = calculateQty();
      pendingMesaSubmit = {
        qty: qty,
        width: inputLargura.value,
        length: inputComprimento.value
      };
    }

    inputLargura.addEventListener('input', function () {
      setError(errorLargura, inputLargura.value !== '' ? validateValue(inputLargura.value, larguraMin, larguraMax) : '');
      syncSubmitWithProductForm();
    });

    inputLargura.addEventListener('blur', function () {
      setError(errorLargura, validateValue(inputLargura.value, larguraMin, larguraMax));
      syncSubmitWithProductForm();
    });

    inputComprimento.addEventListener('input', function () {
      setError(errorComprimento, inputComprimento.value !== '' ? validateValue(inputComprimento.value, comprimentoMin, null) : '');
      syncSubmitWithProductForm();
    });

    inputComprimento.addEventListener('blur', function () {
      setError(errorComprimento, validateValue(inputComprimento.value, comprimentoMin, null));
      syncSubmitWithProductForm();
    });

    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.addEventListener('click', function (e) {
        if (typeof productForm.isFormValid === 'function' && !productForm.isFormValid()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          setError(errorLargura, validateValue(inputLargura.value, larguraMin, larguraMax));
          setError(errorComprimento, validateValue(inputComprimento.value, comprimentoMin, null));
          if (typeof productForm.refreshValidationMessage === 'function') productForm.refreshValidationMessage();
          return false;
        }
        buildPendingData();
      }, true);
    }

    form.addEventListener('submit', function (e) {
      if (typeof productForm.isFormValid === 'function' && !productForm.isFormValid()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        setError(errorLargura, validateValue(inputLargura.value, larguraMin, larguraMax));
        setError(errorComprimento, validateValue(inputComprimento.value, comprimentoMin, null));
        if (typeof productForm.refreshValidationMessage === 'function') productForm.refreshValidationMessage();
        return false;
      }
      buildPendingData();
    }, true);

    syncSubmitWithProductForm();
  }

  function ecCartMesaGetSectionsPayload() {
    var out = [];
    var main = document.getElementById('main-cart-items');
    if (!main || !main.dataset.id) return out;
    out.push({ id: 'main-cart-items', section: main.dataset.id, selector: '.js-contents' });
    out.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    out.push({ id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' });
    var foot = document.getElementById('main-cart-footer');
    if (foot && foot.dataset.id) {
      out.push({ id: 'main-cart-footer', section: foot.dataset.id, selector: '.js-contents' });
    }
    return out;
  }

  function ecCartMesaResetCartLoadingUi() {
    var mainBlk = document.getElementById('main-cart-items');
    var drawerBlk = document.getElementById('CartDrawer-CartItems');
    if (mainBlk) mainBlk.classList.remove('cart__items--disabled');
    if (drawerBlk) drawerBlk.classList.remove('cart__items--disabled');
    document.querySelectorAll('cart-items .loading__spinner, cart-drawer-items .loading__spinner').forEach(function (sp) {
      sp.classList.add('hidden');
    });
    var lineStatus = document.getElementById('shopping-cart-line-item-status');
    if (lineStatus) lineStatus.setAttribute('aria-hidden', 'true');
  }

  function ecCartMesaPaintSections(parsedState, sections) {
    if (!parsedState || !parsedState.sections) return;
    var cartItems = document.querySelector('cart-items');
    if (cartItems && parsedState.item_count !== undefined) {
      cartItems.classList.toggle('is-empty', parsedState.item_count === 0);
    }
    var cartDrawerWrapper = document.querySelector('cart-drawer');
    if (cartDrawerWrapper && parsedState.item_count !== undefined) {
      cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    }
    var cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter && parsedState.item_count !== undefined) {
      cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    }
    sections.forEach(function (section) {
      var host = document.getElementById(section.id);
      if (!host) return;
      var html = parsedState.sections[section.section];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var innerTarget = doc.querySelector(section.selector);
      if (!innerTarget) return;
      var elReplace = host.querySelector(section.selector) || host;
      elReplace.innerHTML = innerTarget.innerHTML;
    });
    document.querySelectorAll('.ec-calculadora-mesa--cart').forEach(function (el) {
      el.removeAttribute('data-ec-cart-init');
      initMesaCartLineCalculator(el);
    });
    ecCartMesaInitHeightControls();
    ecCartMesaResetCartLoadingUi();
    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
    }
  }

  function ecCartMesaFindVariantId(variants, heightIdx, newHeight, o1, o2, o3) {
    if (!variants || heightIdx === null || heightIdx === undefined || heightIdx < 0) return null;
    var cur = [o1 != null ? String(o1) : '', o2 != null ? String(o2) : '', o3 != null ? String(o3) : ''];
    var nh = String(newHeight);
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var o = [v.option1 != null ? String(v.option1) : '', v.option2 != null ? String(v.option2) : '', v.option3 != null ? String(v.option3) : ''];
      if (o[heightIdx] !== nh) continue;
      var ok = true;
      for (var j = 0; j < 3; j++) {
        if (j === heightIdx) continue;
        if (cur[j] !== '' && o[j] !== cur[j]) ok = false;
      }
      if (ok) return v.id;
    }
    return null;
  }

  function ecCartMesaSyncHeightSelect(selectRoot) {
    var label = selectRoot.querySelector('.ec-height-select__label');
    var hid = selectRoot.querySelector('.ec-height-select__input');
    var sel = selectRoot.querySelector('.ec-height-select__option--selected');
    var wrap = selectRoot.querySelector('.ec-height-select__custom-wrapper');
    var customVal = selectRoot.getAttribute('data-custom-height-value') || 'Custom Height (Specify in form)';
    if (sel && label) label.textContent = sel.textContent.trim();
    if (sel && hid) hid.value = sel.getAttribute('data-value') || '';
    if (wrap) {
      var v = sel ? sel.getAttribute('data-value') : '';
      wrap.style.display = v === customVal ? '' : 'none';
    }
  }

  function ecCartMesaInitHeightControls() {
    document.querySelectorAll('.ec-cart-mesa-height .ec-height-select').forEach(ecCartMesaSyncHeightSelect);
  }

  function ecCartMesaRunFixedVariantChange(root, selVal) {
    var lineNum = parseInt(root.getAttribute('data-line'), 10);
    if (isNaN(lineNum)) return;
    var jsonEl = root.querySelector('.ec-cart-mesa-variants-data');
    if (!jsonEl) return;
    var pack;
    try {
      pack = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    var newVariantId = ecCartMesaFindVariantId(
      pack.variants,
      pack.heightOptionIndex,
      selVal,
      root.getAttribute('data-option1'),
      root.getAttribute('data-option2'),
      root.getAttribute('data-option3')
    );
    if (!newVariantId) return;
    var sections = ecCartMesaGetSectionsPayload();
    if (sections.length === 0) return;
    var url = (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change';
    var lineErr = document.getElementById('Line-item-error-' + lineNum);
    var errText = lineErr ? lineErr.querySelector('.cart-item__error-text') : null;
    var keepQty = parseInt(root.getAttribute('data-line-quantity'), 10) || 1;
    var bodyFixed = {
      line: lineNum,
      quantity: keepQty,
      id: newVariantId,
      properties: {
        Width: '',
        Length: '',
        '_Square meters': '',
        '_Square feets': '',
        _is_calculadora_mesa: 'Sim'
      },
      sections: sections.map(function (s) { return s.section; }),
      sections_url: window.location.pathname
    };
    fetch(url, Object.assign({}, typeof fetchConfig === 'function' ? fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, { body: JSON.stringify(bodyFixed) }))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var parsedState = JSON.parse(text);
        if (parsedState.errors) {
          if (errText) errText.textContent = typeof parsedState.errors === 'string' ? parsedState.errors : (parsedState.description || '');
          return;
        }
        if (errText) errText.textContent = '';
        ecCartMesaPaintSections(parsedState, sections);
      })
      .catch(function () {
        if (errText) errText.textContent = window.cartStrings && window.cartStrings.error ? window.cartStrings.error : '';
      });
  }

  function initMesaCartLineCalculator(container) {
    if (container.getAttribute('data-ec-cart-init') === '1') return;
    var root = container.closest('.ec-cart-mesa-height');
    if (!root) return;

    var inputLargura = container.querySelector('.ec-calculadora-mesa__largura');
    var inputComprimento = container.querySelector('.ec-calculadora-mesa__comprimento');
    var applyBtn = container.querySelector('.ec-calculadora-mesa__apply-cart');
    if (!inputLargura || !inputComprimento || !applyBtn) {
      setTimeout(function () { initMesaCartLineCalculator(container); }, 100);
      return;
    }
    container.setAttribute('data-ec-cart-init', '1');

    var larguraMin = parseFloat(container.getAttribute('data-largura-min')) || 0;
    var larguraMaxAttr = container.getAttribute('data-largura-max');
    var larguraMax = larguraMaxAttr !== null && larguraMaxAttr !== '' ? parseFloat(larguraMaxAttr) : null;
    var comprimentoMin = parseFloat(container.getAttribute('data-comprimento-min')) || 0;
    var errorLargura = container.querySelector('.ec-calculadora-mesa__error--largura');
    var errorComprimento = container.querySelector('.ec-calculadora-mesa__error--comprimento');

    function setError(el, msg) {
      if (el) el.textContent = msg || '';
    }

    function calculateQty() {
      var l = (ecMesaParseDimension(inputLargura.value) || 0) / 100;
      var c = (ecMesaParseDimension(inputComprimento.value) || 0) / 100;
      return ecMesaQtyM2FromMeters(l, c);
    }

    inputLargura.addEventListener('input', function () {
      setError(errorLargura, inputLargura.value !== '' ? validateValue(inputLargura.value, larguraMin, larguraMax) : '');
    });
    inputLargura.addEventListener('blur', function () {
      setError(errorLargura, validateValue(inputLargura.value, larguraMin, larguraMax));
    });
    inputComprimento.addEventListener('input', function () {
      setError(errorComprimento, inputComprimento.value !== '' ? validateValue(inputComprimento.value, comprimentoMin, null) : '');
    });
    inputComprimento.addEventListener('blur', function () {
      setError(errorComprimento, validateValue(inputComprimento.value, comprimentoMin, null));
    });

    applyBtn.addEventListener('click', function () {
      var lineNum = parseInt(root.getAttribute('data-line'), 10);
      if (isNaN(lineNum)) return;
      var heightSelect = root.querySelector('.ec-height-select');
      if (!heightSelect) return;
      var selected = heightSelect.querySelector('.ec-height-select__option--selected');
      if (!selected) return;
      var selVal = selected.getAttribute('data-value') || '';
      var customVal = heightSelect.getAttribute('data-custom-height-value') || 'Custom Height (Specify in form)';
      if (selVal !== customVal) return;
      var sections = ecCartMesaGetSectionsPayload();
      if (sections.length === 0) return;
      var url = (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change';
      var lineErr = document.getElementById('Line-item-error-' + lineNum);
      var errText = lineErr ? lineErr.querySelector('.cart-item__error-text') : null;
      var eL = validateValue(inputLargura.value, larguraMin, larguraMax);
      var eC = validateValue(inputComprimento.value, comprimentoMin, null);
      setError(errorLargura, eL);
      setError(errorComprimento, eC);
      if (eL || eC) return;
      var qty = calculateQty();
      if (qty < 1) return;
      var body = {
        line: lineNum,
        quantity: qty,
        properties: {
          Width: String(inputLargura.value),
          Length: String(inputComprimento.value),
          '_Square meters': String(qty),
          '_Square feets': '',
          _is_calculadora_mesa: 'Sim'
        },
        sections: sections.map(function (s) { return s.section; }),
        sections_url: window.location.pathname
      };
      fetch(url, Object.assign({}, typeof fetchConfig === 'function' ? fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, { body: JSON.stringify(body) }))
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var parsedState = JSON.parse(text);
          if (parsedState.errors) {
            if (errText) errText.textContent = typeof parsedState.errors === 'string' ? parsedState.errors : (parsedState.description || '');
            return;
          }
          if (errText) errText.textContent = '';
          ecCartMesaPaintSections(parsedState, sections);
        })
        .catch(function () {
          if (errText) errText.textContent = window.cartStrings && window.cartStrings.error ? window.cartStrings.error : '';
        });
    });
  }

  if (!window.ecCartMesaHeightDelegated) {
    window.ecCartMesaHeightDelegated = true;
    document.addEventListener('click', function (e) {
      var rootM = e.target.closest('.ec-cart-mesa-height');
      if (!rootM) return;
      var trig = e.target.closest('.ec-height-select__trigger');
      if (trig && rootM.contains(trig)) {
        e.preventDefault();
        var hs = trig.closest('.ec-height-select');
        if (!hs || !rootM.contains(hs)) return;
        hs.classList.toggle('ec-height-select--open');
        trig.setAttribute('aria-expanded', hs.classList.contains('ec-height-select--open') ? 'true' : 'false');
        return;
      }
      var opt = e.target.closest('.ec-height-select__option');
      if (opt && rootM.contains(opt)) {
        e.preventDefault();
        var hs2 = opt.closest('.ec-height-select');
        if (!hs2) return;
        hs2.querySelectorAll('.ec-height-select__option').forEach(function (li) {
          li.classList.remove('ec-height-select__option--selected');
          li.setAttribute('aria-selected', 'false');
        });
        opt.classList.add('ec-height-select__option--selected');
        opt.setAttribute('aria-selected', 'true');
        ecCartMesaSyncHeightSelect(hs2);
        if (hs2.classList.contains('ec-height-select--in-accordion')) {
          hs2.classList.remove('ec-height-select--open');
          var tr = hs2.querySelector('.ec-height-select__trigger');
          if (tr) tr.setAttribute('aria-expanded', 'false');
        }
        var selValPick = opt.getAttribute('data-value') || '';
        var customValPick = hs2.getAttribute('data-custom-height-value') || 'Custom Height (Specify in form)';
        if (selValPick !== customValPick) {
          ecCartMesaRunFixedVariantChange(rootM, selValPick);
        }
      }
    });
  }

  function ecMesaSetSqftActiveMedia(sectionId, mediaId) {
    if (!sectionId || !mediaId) return;
    function tryOnce() {
      var mainPi = document.getElementById('MainProduct-' + sectionId);
      if (!mainPi) return false;
      var mg = mainPi.querySelector('media-gallery');
      if (!mg || typeof mg.setActiveMedia !== 'function') return false;
      if (!mg.querySelector('[data-media-id="' + mediaId + '"]')) return false;
      mg.setActiveMedia(mediaId, false);
      return true;
    }
    if (tryOnce()) return;
    requestAnimationFrame(function () {
      if (tryOnce()) return;
      window.setTimeout(function () {
        if (tryOnce()) return;
        window.setTimeout(tryOnce, 120);
      }, 50);
    });
  }

  function ecMesaPdpSyncGate(gate) {
    var sectionId = gate.getAttribute('data-section-id');
    if (!sectionId) return;
    var productInfo = document.getElementById('ProductInfo-' + sectionId);
    if (!productInfo) return;
    var heightRoot = productInfo.querySelector('.ec-height-select[data-ec-mesa-gate="true"]');
    if (!heightRoot) return;
    var customLabel = heightRoot.getAttribute('data-custom-height-value') || gate.getAttribute('data-custom-dimension-label') || '';
    var sel = heightRoot.querySelector('.ec-height-select__option--selected');
    var val = sel ? sel.getAttribute('data-value') : '';
    var isCustom =
      (val === customLabel && customLabel !== '') ||
      (sel && sel.getAttribute('data-ec-mesa-custom-dimension') === 'true');
    gate.style.display = isCustom ? '' : 'none';
    var form = productInfo.querySelector('product-form form');
    var vidInput = form ? form.querySelector('input[name="id"]') : null;
    var sqftVid = gate.getAttribute('data-sqft-variant-id');
    if (isCustom && sqftVid && vidInput && String(vidInput.value) !== String(sqftVid)) {
      vidInput.value = sqftVid;
      vidInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (isCustom) {
      var activeMediaId = gate.getAttribute('data-sqft-active-media-id');
      if (activeMediaId) {
        ecMesaSetSqftActiveMedia(sectionId, activeMediaId);
      }
    }
    document.dispatchEvent(new CustomEvent('product-form:validate'));
    ecMesaUpdateSimQtyForSection(sectionId);
    ecMesaSyncDefaultBuyVisibility(productInfo, sectionId);
  }

  function ecInitMesaPdpGates() {
    document.querySelectorAll('.ec-mesa-calculator-gate[data-ec-mesa-gate="true"]').forEach(function (gate) {
      var sectionId = gate.getAttribute('data-section-id');
      if (!sectionId || gate.getAttribute('data-ec-mesa-pdp-bound') === '1') return;
      gate.setAttribute('data-ec-mesa-pdp-bound', '1');
      var productInfo = document.getElementById('ProductInfo-' + sectionId);
      if (!productInfo) return;
      var heightRoot = productInfo.querySelector('.ec-height-select[data-ec-mesa-gate="true"]');
      if (!heightRoot) return;
      var sync = function () {
        ecMesaPdpSyncGate(gate);
      };
      function onHeightOptionClick(e) {
        if (!productInfo.contains(e.target)) return;
        var opt = e.target.closest('.ec-height-select__option');
        if (!opt || !heightRoot.contains(opt)) return;
        setTimeout(sync, 0);
      }
      document.addEventListener('click', onHeightOptionClick, true);
      document.addEventListener('click', onHeightOptionClick, false);
      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
          if (!ev.data || String(ev.data.sectionId) !== String(sectionId)) return;
          setTimeout(sync, 80);
        });
      }
      sync();
    });
  }

  function initAll() {
    document.querySelectorAll('.ec-calculadora-mesa[data-block-id]').forEach(function (el) {
      var blockId = el.getAttribute('data-block-id');
      if (blockId) initMesaCalculadora(blockId);
    });
    document.querySelectorAll('.ec-calculadora-mesa--cart').forEach(function (el) {
      initMesaCartLineCalculator(el);
    });
    ecCartMesaInitHeightControls();
    ecInitMesaPdpGates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
